(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cml-hw-hero"] && !Shopify.designMode) return;
  try {
    
  // Halloween landing sliders. Clicks and scrolls are delegated, so they survive theme-editor
  // section reloads.
  //   [data-hw-slider]  wrapper
  //   [data-hw-track]   scroll-snap track, children are slides
  //   [data-hw-prev] / [data-hw-next]  arrows, disabled at either end
  //   [data-hw-dot="n"] dots: one per scroll position, not per slide. With 3 slides in view
  //                     and 6 slides there are 4 positions, so dots 5 and 6 are hidden.
  // A slider with nothing to scroll gets .is-static, which hides its arrows and dots.
  (function () {
    function step(track) {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync(track) {
      var root = track.closest('[data-hw-slider]');
      if (!root) return;
      var size = step(track);
      var max = track.scrollWidth - track.clientWidth;
      var visible = Math.max(1, Math.round(track.clientWidth / size));
      var positions = Math.max(1, track.children.length - visible + 1);
      var index = track.scrollLeft >= max - 2 ? positions - 1 : Math.round(track.scrollLeft / size);

      root.classList.toggle('is-static', max <= 1);
      root.querySelectorAll('[data-hw-dot]').forEach(function (dot, i) {
        dot.hidden = i >= positions;
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var prev = root.querySelector('[data-hw-prev]');
      var next = root.querySelector('[data-hw-next]');
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    function syncAll(scope) {
      (scope || document).querySelectorAll('[data-hw-track]').forEach(sync);
    }

    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-hw-prev], [data-hw-next], [data-hw-dot]');
      if (!control) return;
      var root = control.closest('[data-hw-slider]');
      var track = root && root.querySelector('[data-hw-track]');
      if (!track) return;

      if (control.hasAttribute('data-hw-dot')) {
        track.scrollTo({ left: parseInt(control.getAttribute('data-hw-dot'), 10) * step(track) });
        return;
      }
      var dir = control.hasAttribute('data-hw-next') ? 1 : -1;
      track.scrollBy({ left: dir * step(track) });
    });

    // scroll does not bubble, so listen in the capture phase.
    document.addEventListener(
      'scroll',
      function (event) {
        var track = event.target;
        if (track.matches && track.matches('[data-hw-track]')) sync(track);
      },
      true
    );

    window.addEventListener('resize', function () {
      syncAll();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        syncAll();
      });
    } else {
      syncAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      syncAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cml-hw-photo-strip"] && !Shopify.designMode) return;
  try {
    
  // The strip clips its overflow, so loading="lazy" would only fetch a photo as it slides
  // into view, leaving a blank square for a moment. Once the strip comes within ~800px of
  // the screen, every photo in it is switched to eager so they are all in before they show.
  (function () {
    function arm(strip) {
      if (strip.dataset.hwArmed) return;
      strip.dataset.hwArmed = '1';
      var load = function () {
        strip.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      };
      if (!('IntersectionObserver' in window)) return load();
      var io = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            load();
            io.disconnect();
          }
        },
        { rootMargin: '800px 0px' }
      );
      io.observe(strip);
    }

    function init(scope) {
      (scope || document).querySelectorAll('.cml-hw-strip').forEach(arm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
